import usePenetrationReportV2Store from '../../stores/penetrationReportV2Store';
import { SignalTileData, SignalTileKey, SignalTileKeyType } from '../../services/penetrationReportV2/types';

const TILE_ICON: Record<SignalTileKeyType, { symbol: string; className: string }> = {
  [SignalTileKey.HIGH_CRIME]: { symbol: '!', className: 'pr2-signal-crime' },
  [SignalTileKey.HIGH_PURCHEK_CONCENTRATION]: { symbol: '◎', className: 'pr2-signal-density' },
  [SignalTileKey.CART_ORDINANCE]: { symbol: '§', className: 'pr2-signal-ordinance' },
};

interface SignalTilesProps {
  tiles: SignalTileData[];
  comparisonEnabled: boolean;
}

function SignalTiles({ tiles, comparisonEnabled }: SignalTilesProps) {
  const selectedSignalTile = usePenetrationReportV2Store((s) => s.selectedSignalTile);
  const toggleSignalTile = usePenetrationReportV2Store((s) => s.toggleSignalTile);

  return (
    <section className="pr2-signals">
      {tiles.map((tile) => {
        const icon = TILE_ICON[tile.key];
        const isSelected = selectedSignalTile === tile.key;
        return (
          <button
            type="button"
            key={tile.key}
            className={`pr2-signal ${icon.className} ${isSelected ? 'active' : ''}`}
            aria-pressed={isSelected}
            onClick={() => toggleSignalTile(tile.key)}
          >
            <span className="pr2-signal-icon">{icon.symbol}</span>
            <div>
              <small>{tile.label}</small>
              <strong>
                {tile.currentPct.toFixed(1)}% <em>{tile.acquiredCount.toLocaleString()} acquired</em>
              </strong>
              {comparisonEnabled && (
                <p>
                  Previous {tile.priorPct.toFixed(1)}% ·{' '}
                  <b className={tile.deltaPct >= 0 ? 'positive' : 'negative'}>
                    {tile.deltaPct >= 0 ? '↑' : '↓'} {Math.abs(tile.deltaPct).toFixed(1)} pp
                  </b>
                </p>
              )}
            </div>
          </button>
        );
      })}
    </section>
  );
}

export default SignalTiles;
